import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import errorHandle from '../../features/errorHandle';

const ErrorPageContainer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const code = query.get('code') || '';

  useEffect(() => {
    dispatch(errorHandle(code, true));
  }, []);

  return <></>;
};

export default ErrorPageContainer;
